export default {
  title: 'Ajustar Encomenda',
  product_info: {
    earn_points: 'Ganhe {{points}} Pontos',
  },
};
